<template>
  <svg v-if="iconName" class="svg-icon" :class="iconClasses">
    <use
      xmlns:xlink="http://www.w3.org/1999/xlink"
      :xlink:href="iconName"
    ></use>
  </svg>
</template>

<script>
export default {
  props: {
    name: String,
    size: {
      type: String,
      default: "small"
    },
    positive: {
      type: Boolean,
      default: false
    },
    negative: {
      type: Boolean,
      default: false
    },
    spin: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    iconsPath() {
      const { iconsPath } = this.$store.state;
      if (iconsPath) {
        return iconsPath["/assets/svg/user/icons.svg"];
      }
      return "/assets/svg/user/icons.svg";
    },
    iconClasses() {
      return {
        "-positive": this.positive,
        "-negative": this.negative,
        "-x16": this.size === "small",
        "-x20": this.size === "medium",
        "-x24": this.size === "large",
        "-x32": this.size === "largex",
        "-x48": this.size === "huge",
        "-x150": this.size === "giant",
        "-spin": this.spin
      };
    },
    iconName() {
      if (this.iconsPath) {
        return `${this.iconsPath}#svg-${this.name}`;
      }
      return null;
    }
  },
  created() {
    this.$store.dispatch("fetchIconsPath");
  }
};
</script>
